import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { RenderHtml } from '@src/common/RenderHtml';
import Markdown from 'markdown-to-jsx';

const Wrapper = styled('div', {
  padding: '16px 32px 32px 32px',
  fontSize: '15px',
  b: {
    fontWeight: 400,
  },
});

const StyledUL = styled('ul', {
  listStyleType: 'revert',
  marginBottom: '20px',
  color: 'rgb(0, 0, 0)',
  paddingLeft: '40px',
  fontSize: '14px',
});

const StyledLI = styled('li', {
  fontWeight: 'normal',
  fontSize: '14px',
});

const DescWithNote = styled('div', {});

const Note = styled('p', {
  marginBottom: 0,
  fontSize: '14px',
});

const StyledTable = styled('table', {
  borderCollapse: 'collapse',
  width: '100%',
  marginBottom: '16px',
});

const StyledTr = styled('tr', {});

const StyledTh = styled('th', {
  border: '1px solid #ccc',
  padding: '8px',
  backgroundColor: '#f6f8fa',
  fontWeight: 'bold',
  textAlign: 'left',
});

const StyledTd = styled('td', {
  border: '1px solid #ccc',
  padding: '8px',
});

const StyledBr = styled('br', {});

const StyledSpan = styled('span', {});

const StyledDiv = styled('div', {});

export const APIDetailsV3 = ({ currentApi, isMarkdown }) => {
  console.log('Rendering APIDetailsV3 with isMarkdown:', isMarkdown);
  const renderedDescription = isMarkdown ? (
    <Markdown
      options={{
        disableParsingRawHTML: false,
        overrides: {
          ul: StyledUL,
          li: StyledLI,
          p: DescWithNote,
          note: Note,
          table: StyledTable,
          tr: StyledTr,
          th: StyledTh,
          td: StyledTd,
          // Also add other common HTML elements
          br: StyledBr,
          span: StyledSpan,
          div: StyledDiv,
        },
      }}
    >
      {currentApi.description}
    </Markdown>
  ) : (
    <RenderHtml>{currentApi.description}</RenderHtml>
  );

  return <Wrapper>{renderedDescription}</Wrapper>;
};

APIDetailsV3.propTypes = {
  currentApi: PropTypes.shape({ description: PropTypes.string }),
  isMarkdown: PropTypes.bool,
};

APIDetailsV3.defaultProps = {
  currentApi: { description: '' },
  isMarkdown: false,
};
